import { configureStore } from '@reduxjs/toolkit';
import driverReducer from '../Component/Paneldriver/DriverSlice/Driverslice';
import bookingReducer from '../Component/Paneltours/PanelTourSlice/PanelTourSlice';


export const store = configureStore({
    reducer: {
        driver: driverReducer,
        booking: bookingReducer,
    }
});

export default store;
